    
    import React, { useState,useEffect,useCallback,useMemo} from 'react';
    import IconButton from '@mui/material/IconButton';
    import CloseIcon from '@mui/icons-material/Close';
    import DeleteIcon from '@mui/icons-material/Delete';
    import {  useNavigate} from 'react-router-dom';
    import { DataGrid, GridToolbar } from '@mui/x-data-grid';
    import ConfirmationButton from './ConfirmationButton'
    import Helper from '../pages/Helper'

    export default function DynamicDataGridComponent({customcolumns=null, rows=null, name, rowid = null, roleaccess= null, handleDynamicAction = null, width=null}) {
        // const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
        const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
            [name] :{}
        });
       
        const [newColumn, setNewColumn] = React.useState({
            [name] : []
        });
        const [newRows, setNewRows] = React.useState({
            [name]:[]
        });
        const [filterModel , setFilterModel] = React.useState({
            [name] : {
                items: [],
                quickFilterExcludeHiddenColumns: true,
                quickFilterValues: [''],
            }
        });
        
        

        const Grid = () =>{
            setNewRows({[name]:[]})
            //newRows[name] = []
           // console.log(rows.length)
            if(rows.length > 0)
                 {   
                     var newRow = rows.map(function(item,index) {  
                         return {
                           No: index + 1,
                           ...item
                         }
                     })
                    
                     setNewRows({[name] : newRow})
                    
                     if(customcolumns == null){
                         var columns = [];
                         var count = 0;
                         for(let key in newRows[name][0]) 
                             {
                                // console.log(width[count])
                                 if(key == rowid){
                                     const myObj = {};
                                     const a = rowid;
                                     myObj[a] = false;
                                   
                                     setColumnVisibilityModel(myObj)
                                 }
                               
                                 switch (key) {
                                     case "button-delete":
                                         {
                                            var data = {
                                            // flex: 1,
                                            width: width[count],
                                            renderCell:(params) =>(
                                                     <ConfirmationButton classname='btn btn-danger' text="Do you want delete this data?" type="button"  title="Delete"  disabled={!roleaccess.DELETE}  onClick={() => handleDynamicAction(params.row)} >
                                                         <DeleteIcon sx={{ fontSize: 15 }}/> 
                                                     </ConfirmationButton>
                                                 )
                                             }
 
                                             columns.push(data);
                                             break;
                                         };
                                     case "button-update":
                                             {
                                                var data = {
                                                //  flex: 1,
                                                  width: width[count],
                                                 renderCell:(params) =>(
                                                         <button className='btn btn-success' title='Edit' onClick={(e) => handleDynamicAction(params.row)} disabled={!roleaccess.UPDATE}>Edit</button> 
                                                     )
                                                 }
     
                                                 columns.push(data);
                                                 break;
                                             };
                                     case "button-custom":
                                                 {
                                                   
                                                    var data = {
                                                       //  flex: 1,
                                                         field:"action",
                                                         headerName:'',
                                                         width: width[count],
                                                         renderCell:(params) =>(
                                                             
                                                             <button className='btn btn-primary' title={newRows[name][0][key]} onClick={(e) => handleDynamicAction(e,params.row)} disabled={!roleaccess.READ} type='button'>{newRows[name][0][key]}</button> 
                                                         )
                                                     }
         
                                                     columns.push(data);
                                                     break;
                                                 };
                                     default:{
                                         var data = { field: `${key}`, headerName: `${key.replaceAll('_',' ')}`,  width: width[count], valueGetter:({ value }) => {
                                             if(value)
                                             {
                                                 
                                                 //console.log(key, (rows[0][key]).toString())
                                                 if(typeof newRows[0][key] == "string" && new Date((newRows[name][0][key]).toString()) != "Invalid Date"){
                                                    // return "hai"
                                                     return Helper.GetDateDDMMYYYY(value);
                                                 }else if(isNaN(newRows[0][key])== false && (typeof newRows[name][0][key] == "number")){
                                                     //return "hei"
                                                     return Helper.formatAsCurrency(value);
                                                 }else{
                                                     return value;
                                                 }
                                               
                                             }
                                         }}
 
                                         columns.push(data);
                                         break;
                                     }
                                 }
                                 count++;
                             }
                         setNewColumn({[name] : columns})
                        
                     }else{
                         setNewColumn({[name] : customcolumns})
                         
                     }
                   
                 }
        }

        useEffect(() => {
            Grid();
               
        }, [customcolumns,rows]);

        // const getRowId = useMemo((row) => {
        //     if(rowid)
        //         {
        //             for(let key in row) {
        //                 if(key == rowid){
                           
        //                     return row[key] 
        //                 }
        //             }
        //         }
    
        //         return row.id;
        //   }, []);

        function getRowId(row) {
            if(rowid)
            {
                for(let key in row) {
                    if(key == rowid){
                       
                        return row[key] 
                    }
                }
            }

            return row.id;
        }

        return( 
             <DataGrid className='fonty'
                       columns={newColumn[name]}
                       rows={newRows[name]}
                       disableColumnFilter
                       disableDensitySelector
                       disableColumnSelector
                       slots={{ toolbar: GridToolbar }}
                       filterModel={filterModel[name]}
                       onFilterModelChange={(newModel) => {
                        var data = {
                            [name] : newModel
                        }
                            setFilterModel(data)
                       }}
                       slotProps={{ toolbar: { showQuickFilter: true } }}
                       columnVisibilityModel={columnVisibilityModel[name]}
                       onColumnVisibilityModelChange={(newModel) =>
                       {
                            var data = {
                                [name] : newModel
                            }
                            setColumnVisibilityModel(data)
                       }
                        
                       }
                       getRowId={getRowId}
                       id={name}
                       
                      // getRowId={(row) => row.id}
            />
        )
    }
    
    